import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faChartLine,
    faUser
} from '@fortawesome/free-solid-svg-icons';
import { Badge } from 'react-bootstrap';
import { toggleInnerSidebar } from '../../features/ui/uiSlice';
import { fetchUnreadCount } from '../../features/notifications/notificationsSlice';
import { InnerSidebar } from '../InnerSidebar/InnerSidebar';
import styles from './Navbar.module.scss';
import { broadcastActivity } from '../../utils/activityBroadcast';

export const NavbarLeft = () => {
    const isAuthenticated = useSelector(state => state.authentication.isAuthenticated);
    const location = useLocation();
    const dispatch = useDispatch();
    const unreadCount = useSelector(state => state.notifications?.unreadCount || 0);

    // Fetch unread count when component mounts and periodically
    useEffect(() => {
        if (isAuthenticated) {
            dispatch(fetchUnreadCount());
            
            // Poll every 60 seconds
            const interval = setInterval(() => {
                dispatch(fetchUnreadCount());
            }, 60000);
            
            return () => clearInterval(interval);
        }
    }, [isAuthenticated, dispatch]);

    if (!isAuthenticated) {
        return null;
    }

    const handle360LogoClick = () => {
        dispatch(toggleInnerSidebar());

        broadcastActivity();
    };

    const topNavigationItems = [
        {
            logoSrc: '/logo/360-logo.png',
            onClick: handle360LogoClick,
            label: 'Home',
            className: 'nav-home'
        },
        {
            logoSrc: '/logo/QA-logo.png',
            path: '/projects',
            label: 'Projects',
            className: 'nav-projects'
        }
    ];

    const bottomNavigationItems = [
        {
            logoSrc: '/logo/Notification-Icon.png',
            path: '/notifications',
            label: 'Notifications',
            className: 'nav-notifications'
        },
        // {
        //     icon: faChartLine,
        //     path: '/statistics',
        //     label: 'Statistics',
        //     className: 'nav-statistics'
        // },
        {
            logoSrc: '/logo/instruction-logo.png',
            path: '/user-manual',
            label: 'Q&A',
            className: 'nav-help'
        },
        {
            icon: faUser,
            path: '/profile',
            label: 'Profile',
            className: 'nav-profile'
        }
    ];

    const isActiveRoute = (path) => {
        if (path === '/' && location.pathname === '/') {
            return true;
        }
        return path !== '/' && location.pathname.startsWith(path);
    };

    return (
        <>
            <InnerSidebar />
            <nav className={styles['navbar-left']}>
                <div className={styles['nav-top']}>
                    {topNavigationItems.map((item, index) => {
                        if (item.onClick) {
                            // Handle 360 logo with onClick
                            return (
                                <div
                                    key={index}
                                    onClick={item.onClick}
                                    className={`${styles['nav-item']} ${styles[item.className]}`}
                                    title={item.label}
                                    style={{ cursor: 'pointer' }}
                                >
                                    {item.logoSrc ? (
                                        <img
                                            src={item.logoSrc}
                                            alt={item.label}
                                            className={styles['nav-logo']}
                                        />
                                    ) : (
                                        <FontAwesomeIcon icon={item.icon} />
                                    )}
                                </div>
                            );
                        } else {
                            // Handle other navigation items with Link
                            return (
                                <Link
                                    key={index}
                                    to={item.path}
                                    className={`${styles['nav-item']} ${styles[item.className]} ${
                                        isActiveRoute(item.path) ? styles['nav-item-active'] : ''
                                    }`}
                                    title={item.label}
                                >
                                    {item.logoSrc ? (
                                        <img
                                            src={item.logoSrc}
                                            alt={item.label}
                                            className={styles['nav-logo']}
                                        />
                                    ) : (
                                        <FontAwesomeIcon icon={item.icon} />
                                    )}
                                    {item.path === '/notifications' && unreadCount > 0 && (
                                        <Badge 
                                            bg="danger" 
                                            className={styles['notification-badge']}
                                        >
                                            {unreadCount > 99 ? '99+' : unreadCount}
                                        </Badge>
                                    )}
                                </Link>
                            );
                        }
                    })}
                </div>

            <div className={styles['nav-bottom']}>
                {bottomNavigationItems.map((item, index) => (
                    <Link
                        key={index}
                        to={item.path}
                        className={`${styles['nav-item']} ${styles[item.className]} ${
                            isActiveRoute(item.path) ? styles['nav-item-active'] : ''
                        }`}
                        title={item.label}
                    >
                        {item.logoSrc ? (
                            <img
                                src={item.logoSrc}
                                alt={item.label}
                                className={styles['nav-logo']}
                            />
                        ) : (
                            <FontAwesomeIcon icon={item.icon} />
                        )}
                        {item.path === '/notifications' && unreadCount > 0 && (
                            <Badge 
                                bg="danger" 
                                className={styles['notification-badge']}
                            >
                                {unreadCount > 99 ? '99+' : unreadCount}
                            </Badge>
                        )}
                    </Link>
                ))}
            </div>
        </nav>
        </>
    );
};
